const PropTypes = require('prop-types');
// @vendor
const React = require('react');

// @utils
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
    BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE,
    TYPE_PLANS,
    BROKER_ADVANCED_SEARCH_SLIDER_MIN,
    BROKER_ADVANCED_SEARCH_SLIDER_MAX,
    OK_SLIDER_TYPE_RANGE,
    PERCENTAGE_SYMBOL,
} = require('constants/index');

// @components
const MorningStarCheckboxGroup = require('components/broker/morningStarCheckboxGroup/morningStarCheckboxGroup');
const OKSliderInput = require('commonsComponents/OKSliderInput');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');

// @localComponents
const RiskButtonsGroup = require('./commons/riskButtons');

class PlansFilters extends React.Component {
    constructor(props) {
        super(props);

        this.handlePromoterChange = this.handlePromoterChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handleMorningStar = this.handleMorningStar.bind(this);
        this.handleProfitabilitySlider = this.handleProfitabilitySlider.bind(this);
        this.handleRisk = this.handleRisk.bind(this);
        this.adaptSelectOptions = this.adaptSelectOptions.bind(this);
        this.handleToggleAdditionalFilters = this.handleToggleAdditionalFilters.bind(this);
        this.handleNameInput = this.handleNameInput.bind(this);
        this.handleProductChange = this.handleProductChange.bind(this);
        this.handleTermInputChange = this.handleTermInputChange.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    componentDidMount() {
        const { searchState } = this.props;
        const term = searchState.getIn(['selectedValues', TYPE_PLANS, 'term']);

        if (term) {
            this.handleProductChange(term);
        }
    }

    adaptSelectOptions(options) {
        options = options.toJS();
        return [
            {value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText('broker-allOptionsF')},
            ...options.map(item => {
                return {value: item.id, label: item.name};
            })
        ];
    }

    additionalFilters(searchState) {
        const lowRiskIsActive = searchState.getIn(['selectedValues', TYPE_PLANS, 'risk', 'low']);
        const mediumRiskIsActive = searchState.getIn(['selectedValues', TYPE_PLANS, 'risk', 'medium']);
        const highRiskIsActive = searchState.getIn(['selectedValues', TYPE_PLANS, 'risk', 'high']);

        const stars = searchState.getIn(['selectedValues', TYPE_PLANS, 'stars']).reduce((prev, curr, currIndex) => {
            return [...prev, { stars: currIndex + 1, checked: curr ? true : false }];
        }, []);

        const profitRange = [
            searchState.getIn(['selectedValues', TYPE_PLANS, 'minProfitabilityRange']),
            searchState.getIn(['selectedValues', TYPE_PLANS, 'maxProfitabilityRange'])
        ];


        return (
            <div className="broker-advanced-search-explore__rest-of-filters">
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__one-third-box">
                        <label className="broker-advanced-search-explore__label">
                            <FormattedText value="broker-advancedSearchRatingMorningstar"/>
                        </label>
                        <MorningStarCheckboxGroup
                            values={stars}
                            onChange={this.handleMorningStar}
                            />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box broker-advanced-search-explore__one-third-box--slider-input">
                        <label className="broker-advanced-search-explore__label">
                            <FormattedText value="broker-advancedSearchProfitabilityRanking"/>
                        </label>
                        <OKSliderInput
                            min={BROKER_ADVANCED_SEARCH_SLIDER_MIN}
                            max={BROKER_ADVANCED_SEARCH_SLIDER_MAX}
                            minLabel={BROKER_ADVANCED_SEARCH_SLIDER_MIN}
                            maxLabel={BROKER_ADVANCED_SEARCH_SLIDER_MAX}
                            defaultValue={profitRange}
                            type={OK_SLIDER_TYPE_RANGE}
                            onAfterChange={this.handleProfitabilitySlider}
                            unit={PERCENTAGE_SYMBOL}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box">
                        <label className="broker-advanced-search-explore__label">
                            <FormattedText value="broker-advancedSearchPlanFilterRisk" />
                        </label>
                        <RiskButtonsGroup
                            risks={[lowRiskIsActive, mediumRiskIsActive, highRiskIsActive]}
                            onHandleRiskChange={this.handleRisk}
                        />

                    </div>
                </div>
            </div>
        );
    }

    handleCategoryChange(category) {
        this.props.onHandleFieldChange('category', category.value);
    }

    handleMorningStar(stars) {
        this.props.onHandleFieldChange('stars', stars);
    }

    handleNameInput(ev) {
        this.props.onHandleFieldChange('term', ev.target.value);
    }

    handleProductChange(value) {
        this.props.onHandleFieldChange('term', value);
    }

    handleProductSelect(ev) {
        if (ev.id) {
            this.props.onHandleFieldChange('term', ev.id);
            this.props.onHandleFieldChange('selectedProduct', ev.value);
        } else {
            this.props.onHandleFieldChange('term', '');
            this.props.onHandleFieldChange('selectedProduct', '');
        }
    }
    handleProfitabilitySlider(values) {
        this.props.onHandleFieldChange('profitability', values);
    }

    handlePromoterChange(promoter) {
        this.props.onHandleFieldChange('promoter', promoter.value);
    }

    handleRisk(riskType) {
        this.props.onHandleFieldChange('risk', riskType);
    }

    handleTermInputChange(event) {
        this.handleProductChange(event.target.value);
    }

    handleToggleAdditionalFilters() {
        this.props.onHandleToggleAdditionalFilters();
    }

    primaryFilters(searchState, searchSimpleState, showAdditionalFilters) {
        const term = searchState.getIn(['selectedValues', TYPE_PLANS, 'term']);
        const promoters = this.adaptSelectOptions(searchState.getIn(['filters', TYPE_PLANS, 'promoters']));
        const customCategories = this.adaptSelectOptions(searchState.getIn(['filters', TYPE_PLANS, 'customCategories']));
        const activePromoter = searchState.getIn(['selectedValues', TYPE_PLANS, 'promoter']);
        const activeCategory = searchState.getIn(['selectedValues', TYPE_PLANS, 'category']);
        const nameInputLabel = formatText('broker-advancedSearchNameDGSLabel');
        const expandLinkText = formatText('broker-advancedSearchExpandLink');
        const collapseLinkText = formatText('broker-advancedSearchCollapseLink');
        const additionalFiltersToggleButton = showAdditionalFilters ? collapseLinkText : expandLinkText;

        return (
            <div>
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__one-third-box">
                        <label className="broker-advanced-search-explore__label">
                            {nameInputLabel}
                        </label>
                        <InputSafe
                            id="inpBrokerAdvancedSearchTerm"
                            name="advanced-search-name"
                            value={term}
                            onChange={this.handleTermInputChange}
                            type="text"
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchPromoter"
                            label="broker-advancedSearchPromoterLabel"
                            name="advanced-search-promoter"
                            className="broker-advanced-search-explore__promoter-select"
                            options={promoters}
                            value={activePromoter}
                            clearable={false}
                            searchable={false}
                            onChange={this.handlePromoterChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-fifth-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchCategory"
                            label="broker-advancedSearchCategoryLabel"
                            name="advanced-search-category"
                            className="broker-advanced-search-explore__category-select"
                            options={customCategories}
                            value={activeCategory}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleCategoryChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__toggle-button-box">
                        <div id="btnBrokerAdvancedSearchToggleFilters"
                            className="broker-advanced-search-explore__toggle-button"
                            onClick={this.handleToggleAdditionalFilters}
                        >
                            {additionalFiltersToggleButton}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {

        const {
            showAdditionalFilters,
            searchState,
            searchSimpleState
        } = this.props;

        const primaryFilters = this.primaryFilters(searchState, searchSimpleState, showAdditionalFilters);
        const additionalFilters = showAdditionalFilters ? this.additionalFilters(searchState) : undefined;

        return (
            <div className="broker-advanced-search-explore__type-filters">
                {primaryFilters}
                {additionalFilters}
            </div>
        );
    }
}

PlansFilters.propTypes = {
    showAdditionalFilters: PropTypes.bool,
    searchState: PropTypes.object.isRequired,
    searchSimpleState: PropTypes.object.isRequired,
    onHandleFieldChange: PropTypes.func.isRequired,
    onHandleProductChange: PropTypes.func.isRequired,
    onHandleSearchReset: PropTypes.func.isRequired,
    onHandleToggleAdditionalFilters: PropTypes.func.isRequired,
}

module.exports = PlansFilters;